import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ShopifyIntegrationSetupForNRO = lazy(() =>
  import("@scenes/ShopifyIntegrationSetup").then((module) => ({
    default: module.ShopifyIntegrationSetup,
  }))
);

export const alloysShopifyBridgeIdEditNRO: NavigationRoutingObject = {
  Component: ShopifyIntegrationSetupForNRO,
  componentFeatureFlippers: ["shopify"],
  noKnockoutFallback: true,
  section: "partner-integrations",
  heading: (t: I18nT<"dashboard-navigation">) => t("alloys-shopify-bridge-id-edit-nro-heading", "Shopify Edit"),
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("shopify");
  },
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: () => [],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
};
